export const BASE_URL = 'https://social-media-worker.ruchigarg969.workers.dev';
export const BASE_URL_POSTS = BASE_URL + '/api/posts';